// CSRFトークンを取得する関数
export const getCsrfToken = () => {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
};
  
// お酒データを取得する関数
export const fetchDrinks = async (lang, num, start) => {
    const csrfToken = getCsrfToken();
    try {
        const response = await fetch('/latest_post', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify({
                lang,
                num,
                start
            })
        });
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        const data = await response.json();
        return data; // データを呼び出し元に返す
    } catch (error) {
        console.error("Error fetching drinks:", error);
        throw error; // エラーを再スローして呼び出し元で処理
    }
};